module.exports = __webpack_public_path__ + "img/cdn.6d9e2286.png";